import React, { useState, useEffect } from 'react';
export const LxDocIcon = (props) => {
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M3.11127 0H11.1113L14.6668 3.55556V14.2222C14.6668 15.2041 13.8709 16 12.8891 16H3.11127C2.12943 16 1.3335 15.2041 1.3335 14.2222V1.77778C1.3335 0.795938 2.12944 0 3.11127 0Z", fill: `url(#${id})` }),
        React.createElement("rect", { x: "4", y: "10.6667", width: "5.33333", height: "1.33333", fill: "white" }),
        React.createElement("path", { d: "M4 6.66675H12V8.00008H4V6.66675Z", fill: "white" }),
        React.createElement("path", { d: "M11.1113 2.66667V0L14.6669 3.55556H12.0002C11.5093 3.55556 11.1113 3.15759 11.1113 2.66667Z", fill: "white", fillOpacity: "0.5" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "8.00016", y1: "0", x2: "8.00016", y2: "16", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#70A1F6" }),
                React.createElement("stop", { offset: "1", stopColor: "#4389FE" })))));
};
export const LxXlsIcon = (props) => {
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M4.66667 0H16.6667L22 5.33333V21.3333C22 22.8061 20.8061 24 19.3333 24H4.66667C3.19391 24 2 22.8061 2 21.3333V2.66667C2 1.19391 3.19391 0 4.66667 0Z", fill: `url(#${id})` }),
        React.createElement("path", { d: "M16.667 4V0L22.0003 5.33333H18.0003C17.2639 5.33333 16.667 4.73638 16.667 4Z", fill: "white", fillOpacity: "0.5" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.33333 9.33333V17.3333H16.6667V9.33333H7.33333ZM6.66667 8C6.29848 8 6 8.29848 6 8.66667V18C6 18.3682 6.29848 18.6667 6.66667 18.6667H17.3333C17.7015 18.6667 18 18.3682 18 18V8.66667C18 8.29848 17.7015 8 17.3333 8H6.66667Z", fill: "white" }),
        React.createElement("rect", { x: "6", y: "12", width: "12", height: "1.33333", fill: "white" }),
        React.createElement("rect", { x: "11.333", y: "8", width: "10.6667", height: "1.33333", transform: "rotate(90 11.333 8)", fill: "white" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "12", y1: "0", x2: "12", y2: "24", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#60CD93" }),
                React.createElement("stop", { offset: "1", stopColor: "#57BC7E" })))));
};
export const LxUnitableIcon = (props) => {
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M3.77778 0H16.6667L22 5.33333V22.2222C22 23.2041 21.2041 24 20.2222 24H3.77778C2.79594 24 2 23.2041 2 22.2222V1.77778C2 0.795938 2.79594 0 3.77778 0Z", fill: `url(#${id})` }),
        React.createElement("rect", { x: "5.6665", y: "16", width: "8", height: "1.8", fill: "white" }),
        React.createElement("rect", { x: "5.6665", y: "6", width: "8", height: "1.8", fill: "white" }),
        React.createElement("path", { d: "M5.6665 11H11.6665V12.8H5.6665V11Z", fill: "white" }),
        React.createElement("path", { d: "M16.667 4.44444V0L22.0003 5.33333H17.5559C17.065 5.33333 16.667 4.93536 16.667 4.44444Z", fill: "white", "fill-opacity": "0.5" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "17.6665", y1: "2.5", x2: "1.6665", y2: "24", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#FE9132", "stop-opacity": "0.88" }),
                React.createElement("stop", { offset: "1", "stop-color": "#FE9132" })))));
};
